import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getOverallMessageSegments } from "../../redux/actions/messageSegmentSettings";

const InsertMessageSet = ({handleAddBlock }) => {
  const [selectedOptionType, setSelectedOptionType] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [showAddButton, setShowAddButton] = useState(false);

  const [temporaryBlockStorage, setTemporaryBlockStorage] = useState([]);
  const [inputText, setInputText] = useState("");
  const [messageSegmentsList, setMessageSegmentsList] = useState([]);
  const dispatch = useDispatch();
  const messageSegmentsSettings = useSelector(
    (state) => state.messageSegmentsSettings
  );
  const { totalPage, allMessageSegments } = messageSegmentsSettings;

  useEffect(() => {
    dispatch(getOverallMessageSegments());
  }, []);

  // console.log("allMessageSegments", allMessageSegments)
  // console.log("totalPage", totalPage)

  useEffect(() => {
    if (allMessageSegments?.length > 0) {
      setMessageSegmentsList(allMessageSegments);
    }
  }, [allMessageSegments]);

  const onSelectOption = async (val) => {
    setSelectedOptionType(val);
  };

  const insertBlockIntoTempStore = async (type, OptId, OptText, event) => {
    event.preventDefault();
    let OldTemporaryBlockStorage = temporaryBlockStorage;
    if (type == 1) {
      let eachBlockSegmet = {
        type: "id",
        value: OptId,
        contents: "[" + OptText + "]",
      };
      OldTemporaryBlockStorage.push(eachBlockSegmet);
      setSelectedOptionType("");
      setTemporaryBlockStorage(OldTemporaryBlockStorage);
      setShowAddButton(true);
    } else if (type == 2) {
      let eachBlockText = {
        type: "text",
        value: OptText,
        contents: OptText,
      };
      OldTemporaryBlockStorage.push(eachBlockText);
      setSelectedOptionType("");
      setTemporaryBlockStorage(OldTemporaryBlockStorage);
      setInputText("");
      setShowAddButton(true);
    } else {
      let eachBlockText = {
        type: "text",
        value: OptText,
        contents: OptText,
      };
      OldTemporaryBlockStorage.push(eachBlockText);
      setSelectedOptionType("");
      setTemporaryBlockStorage(OldTemporaryBlockStorage);
      setShowAddButton(true);
    }
    setShowOptions(false);
  };

  const storeInMessageBlock = async (event) => {
    // console.log("storeInMessageBlock")
    event.preventDefault();
    await handleAddBlock(temporaryBlockStorage);
    setShowAddButton(false);
    setTemporaryBlockStorage([]);
  };

  const removeMessageBlock = async (index) => {
    // console.log("index", index)
    let blocks = temporaryBlockStorage;
    blocks = blocks.filter((item, i) => i !== index);
    setTemporaryBlockStorage(blocks);
  };

  return (
    <div className="insert-message-set-wrapper">
      <div>
        <div className="temp-blocks-wrapper">
          <button
            className="insertMessageSetButton"
            onClick={() => setShowOptions(true)}
          >
            Insert
          </button>
          {temporaryBlockStorage?.map((data, index) => (
            <div className="message-block-item" key={index}>
              {data.contents}
              <button onClick={() => removeMessageBlock(index)}>X</button>
            </div>
          ))}
        </div>
        {showAddButton ? (
          <button
            type="button"
            onClick={storeInMessageBlock}
            className="add message-segment-add-button"
            style={{ marginTop: "-10px" }}
            disabled={temporaryBlockStorage.length === 0}
          >
            Add
          </button>
        ) : (
          ""
        )}
      </div>
      <div className="message-set-options-wrapper">
        {showOptions && (
          <div className="insertdropdown message-set-options">
            <ul>
              <li>
                <button
                  onClick={() => onSelectOption("message-segment")}
                  href="#"
                  className={`message-set-option-item ${
                    selectedOptionType === "message-segment" && "active"
                  }`}
                >
                  Message Segment
                </button>
                {selectedOptionType === "message-segment" ? (
                  <div className="insertdropdown message-segments-wrapper">
                    <ul className="message-segments">
                      {messageSegmentsList &&
                        messageSegmentsList.map((data, index) => (
                          <li key={index}>
                            <a
                              onClick={(event) =>
                                insertBlockIntoTempStore(
                                  1,
                                  data._id,
                                  data.title,
                                  event
                                )
                              }
                              href="#"
                            >
                              {data.title}
                            </a>
                          </li>
                        ))}
                      {messageSegmentsList?.length === 0 &&
                        "No Segments created."}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </li>

              <li className="second">
                <button
                  onClick={() => onSelectOption("static-text")}
                  href="#"
                  className={`message-set-option-item ${
                    selectedOptionType === "static-text" && "active"
                  }`}
                >
                  Static Text
                </button>
                {selectedOptionType === "static-text" ? (
                  <div className="insertdropdown static-text">
                    <label>Title</label>
                    <textarea
                      name="default_message_text_add"
                      value={inputText}
                      rows={4}
                      onChange={(e) => setInputText(e.target.value)}
                      id="default_message_text_add"
                      className="withtag otherstyle message-segment-input"
                      placeholder="Please Provide Your Static Text"
                      style={{ padding: "6px", minWidth: "210px" }}
                    />
                    <button
                      disabled={!inputText.trim()}
                      onClick={(event) =>
                        insertBlockIntoTempStore(2, "", inputText, event)
                      }
                      className={`done-button ${!inputText ? "disabled" : ""}`}
                      type="submit"
                    >
                      Done
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </li>
              <li>
                <button
                  onClick={() => onSelectOption("keywords")}
                  href="#"
                  className={`message-set-option-item ${
                    selectedOptionType === "keywords" && "active"
                  }`}
                >
                  Keywords
                </button>
                {selectedOptionType === "keywords" ? (
                  <div className="insertdropdown keywords">
                    <ul>
                      <li>
                        <a
                          onClick={(event) =>
                            insertBlockIntoTempStore(
                              3,
                              "",
                              "{first_name}",
                              event
                            )
                          }
                          href="#"
                        >
                          [ First Name ]
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={(event) =>
                            insertBlockIntoTempStore(
                              3,
                              "",
                              "{last_name}",
                              event
                            )
                          }
                          href="#"
                        >
                          [ Last Name ]
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={(event) =>
                            insertBlockIntoTempStore(
                              3,
                              "",
                              "{group_name}",
                              event
                            )
                          }
                          href="#"
                        >
                          [ Group Name ]
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={(event) =>
                            insertBlockIntoTempStore(
                              3,
                              "",
                              "{decline_reason}",
                              event
                            )
                          }
                          href="#"
                        >
                          [ Decline Reason ]
                        </a>
                      </li>
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
export default InsertMessageSet;
